import styles from './IconFeatureGrid.module.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from 'components/Grid/Grid';
import type { AppType, WithCMS } from 'services/cms/typesUtil';
import { IconFeatureGridCard } from './IconFeatureGridCard';
import { IconFeatureGridTitle } from './IconFeatureGridTitle';

type IconFeatureGridProps = AppType.Component<{
  title: string;
  titleColor: string;
  backgroundColor: string;
  extendBackgroundColor: string;
  topColor: string;
  bottomColor: string;
  items: Array<WithCMS<AppType.Content>>;
  headingTagName?: keyof React.ReactHTML;
}>;

export const IconFeatureGrid: React.FC<IconFeatureGridProps> = ({
  title,
  titleColor,
  backgroundColor,
  extendBackgroundColor,
  topColor,
  bottomColor,
  items,
  headingTagName = 'h2',
  ...props
}) => {
  const { t } = useTranslation();
  const extendbackgroundClass = extendBackgroundColor
    ? styles.iconFeatureGridLinear
    : styles.iconFeatureGridNolinear;
  return (
    <section
      className={styles.iconFeatureGrid}
      style={{ backgroundColor: backgroundColor || styles.iconFeatureGridBackgroundColor }}
      {...props._attributes}
      role="main"
      aria-label={t('icon-feature-grid.main-content')}
    >
      <IconFeatureGridTitle title={title} titleColor={titleColor} headingTagName={headingTagName} />
      <div
        className={extendbackgroundClass}
        style={getStyle({ topColor, bottomColor, backgroundColor }, extendBackgroundColor)}
      >
        <Grid container xs={12} className={styles.iconFeatureGridCell}>
          {items?.map(item => (
            <IconFeatureGridCard item={item} key={title} />
          ))}
        </Grid>
      </div>
    </section>
  );
};

const getStyle = ({ topColor, bottomColor, backgroundColor }: any, extendBackgroundColor: any) => {
  const linearProperty = {
    '--linear-color-top': topColor,
    '--linear-color-bottom': bottomColor,
  } as React.CSSProperties;
  const noLinearProperty = {
    '--backgroundColor': backgroundColor,
  } as React.CSSProperties;

  if (extendBackgroundColor) return linearProperty;
  return noLinearProperty;
};
